import { panelActionCellProps } from 'components/RowGroup'
import React from 'react'
import { FlexboxProps, WidthProps } from 'styled-system'

import {
  Row as RowStyles,
  Header as HeaderStyles,
  Cell as CellStyles,
} from './RowGroup.styles'

const RowGroup: React.FC = ({ children }) => <>{children}</>

interface BoxProps extends FlexboxProps, WidthProps {}

const Header: React.FC<BoxProps> = ({ children, ...styles }) => (
  <HeaderStyles {...styles}>{children}</HeaderStyles>
)

interface CellProps extends BoxProps {
  'data-testid'?: string
}

const Cell: React.FC<CellProps> = ({
  children,
  'data-testid': dataTestId,
  ...props
}) => {
  const anyProps = props as any

  /* Workaround to force action cells to be aligned right */
  if (anyProps?.position === panelActionCellProps.position) {
    return (
      <CellStyles className="action" data-testid={dataTestId}>
        {children}
      </CellStyles>
    )
  }

  return (
    <CellStyles data-testid={dataTestId} {...props}>
      {children}
    </CellStyles>
  )
}

interface RowProps extends React.HTMLAttributes<HTMLDivElement>, BoxProps {}

const Row: React.FC<RowProps> = ({ children }) => (
  <RowStyles>{children}</RowStyles>
)

export { Row, Header, Cell }
export default RowGroup
